export default __webpack_public_path__ + "static/media/080_finish_good.vp9.c8597343.webm";